// extracted by mini-css-extract-plugin
export default {"container":"MainContent_container__ZOESc","snackbar":"MainContent_snackbar__ngdn8"};